import {Button} from '@/components/ui/button/Button'
import {Dialog, DialogBody, DialogDismiss, DialogProvider} from '@/components/ui/dialog-atoms/DialogAtoms'
import {Text} from '@/components/ui/text/Text'
import {useTranslation} from '@/translations/i18n'
import {useEffect, useState} from 'react'
import {StyledFooter} from './style'
import {useBlocker} from 'react-router-dom'

const isProd = import.meta.env.MODE == 'production'

export const UnsavedBlocker = ({isBlockerActive}: {isBlockerActive: boolean}) => {
    const {t} = useTranslation()
    const [open, setOpen] = useState(false)

    const blocker = useBlocker(({currentLocation, nextLocation}) => {
        if (currentLocation.pathname == nextLocation.pathname) {
            return false
        }

        return isBlockerActive
    })

    useEffect(() => {
        if (blocker.state == 'blocked' && !isBlockerActive) {
            blocker.reset()
        }
        if (blocker.state == 'blocked' && isBlockerActive) {
            setOpen(true)
        }
    }, [blocker, isBlockerActive])

    useEffect(() => {
        if (isProd) {
            const handleBeforeUnload = (event: BeforeUnloadEvent) => {
                if (isBlockerActive) {
                    event.preventDefault()
                }
            }

            window.addEventListener('beforeunload', handleBeforeUnload)
            return () => {
                window.removeEventListener('beforeunload', handleBeforeUnload)
            }
        }
    }, [isBlockerActive, isProd])

    return (
        <DialogProvider open={open} setOpen={setOpen}>
            <Dialog width="400px">
                <DialogBody gap={2}>
                    <Text render="h1" size="textXl" weight={'500'}>
                        {t('commons:view_unsaved_blocker_title')}
                    </Text>
                    <Text size="textMd" palette="neutral" shade="600">
                        {t('commons:view_unsaved_blocker_paragraph')}
                    </Text>
                </DialogBody>
                <StyledFooter>
                    <DialogDismiss render={<Button variant="secondary">{t('commons:cancel')}</Button>} />
                    <DialogDismiss
                        render={
                            <Button variant="primaryNeutral" onClick={() => blocker.proceed?.()}>
                                {t('commons:view_unsaved_blocker_cta')}
                            </Button>
                        }
                    />
                </StyledFooter>
            </Dialog>
        </DialogProvider>
    )
}
